const Picker = {
  settings: {
    bundle_max: Number(window.productPickerConfig.productAmount),
  },
  Defaults: {
    getAddToCartButton: function () {
      return document.querySelector(".bundle-builder__add")
    },
    bundle: function () {
      return document.querySelector(".bottle-selector")
    },
  },
  Utils: {
    calculateBundleQuantity: function () {
      let bundleQty = 0
      document.querySelectorAll(".bottle-selector .bundle-builder-item").forEach(function (item) {
        bundleQty += Number(item.getAttribute("data-qty"))
      })
      return bundleQty
    },
    calculatePrice: function () {
      let total = 0
      document.querySelectorAll(".bottle-selector .bundle-builder-item").forEach(function (item) {
        const qty = Number(item.getAttribute("data-qty"))
        const price = Number(item.getAttribute("data-item-price"))
        total += price * qty
      })

      const num = total / 100
      return (Math.round(num * 100) / 100).toFixed(2)
    },
    handleDecrease: function (item) {
      const newBundleQty = Picker.Utils.calculateBundleQuantity() - 1
      const newItemQty = Number(item.getAttribute("data-qty")) - 1

      if (newItemQty >= 0) {
        Picker.Utils.updatePickerItem(item, newItemQty, newBundleQty)
      }
    },
    handleIncrease: function (item) {
      const newBundleQty = Picker.Utils.calculateBundleQuantity() + 1
      const newItemQty = Number(item.getAttribute("data-qty")) + 1

      if (Picker.Constraints.isBundleLessThanMax(newBundleQty)) {
        Picker.Utils.updatePickerItem(item, newItemQty, newBundleQty)
      }
    },
    updatePickerItem: function (item, newItemQty, newBundleQty) {
      item.setAttribute("data-qty", newItemQty)
      item.querySelector(".bundle-builder__display-qty").innerHTML = newItemQty

      const decreaseButton = item.querySelector(".decrease")
      if (newItemQty > 0) {
        decreaseButton.classList.remove("inactive")
      } else {
        decreaseButton.classList.add("inactive")
      }

      Picker.Utils.updateQtyButtons()
      Picker.Utils.updateAddButton()
    },
    updateQtyButtons: function () {
      const bundle = Picker.Defaults.bundle()
      const bundleMax = Picker.settings.bundle_max
      const bundleQty = Picker.Utils.calculateBundleQuantity()

      bundle.querySelectorAll(".bundle-builder-item").forEach(function (item) {
        const itemQty = Number(item.getAttribute("data-qty"))

        // Toggle plus button
        const increaseButton = item.querySelector(".increase")
        increaseButton.classList.toggle("inactive", bundleQty >= bundleMax)

        // Toggle minus button
        const decreaseButton = item.querySelector(".decrease")
        decreaseButton.classList.toggle("inactive", itemQty === 0)
      })
    },
    updateAddButton: function () {
      const bundleQty = Picker.Utils.calculateBundleQuantity()
      const bundleMax = Picker.settings.bundle_max

      const button = Picker.Defaults.getAddToCartButton()
      const text = button.querySelector("span")

      const price = Picker.Utils.calculatePrice()

      if (bundleQty < bundleMax) {
        button.setAttribute("disabled", "disabled")
        text.textContent = `Select ${bundleMax - bundleQty} products`
      } else {
        button.removeAttribute("disabled")
        text.textContent = `checkout - $${price}`
      }
    },
  },
  Constraints: {
    isBundleLessThanMax: function (newQty) {
      if (newQty > Picker.settings.bundle_max) {
        console.log("Quantity cannot be greater than maximum.")
        return false
      }
      return true
    },
  },
  Cart: {
    processAddToCart: function () {
      const bundle = Picker.Defaults.bundle()
      const items = Picker.Cart.generateCart(bundle)

      const combinedItems = Object.values(
        items.reduce((accumulator, currentValue) => {
          const { id, quantity } = currentValue
          accumulator[id] = accumulator[id] || { id, quantity: 0 }
          accumulator[id].quantity += quantity
          return accumulator
        }, {}),
      )

      if (combinedItems.length > 0) {
        Picker.Cart.processToCart(combinedItems)
      } else {
        console.log("No items available to add to cart.")
      }
    },
    generateCart: function (bundle) {
      let cart = []

      bundle.querySelectorAll(".bundle-builder-item").forEach(function (item) {
        const qty = Number(item.getAttribute("data-qty"))
        if (qty > 0) {
          const variantId = item.getAttribute("data-variant-id")
          const cartItem = { id: variantId, quantity: qty }
          cart.push(cartItem)
        }
      })

      document.querySelectorAll(".bundle-builder__gift.checked").forEach(function (gift) {
        const variantId = gift.getAttribute("data-id")
        cart.push({ id: variantId, quantity: 1 })
      })

      document.querySelectorAll(".dropdown__filter-selected").forEach(function (dropdown) {
        const variantId = dropdown.getAttribute("data-item-id")
        cart.push({ id: variantId, quantity: 1 })
      })

      return cart
    },
    processToCart: function (items) {
      const data = items.reduce((acc, item) => {
        acc[item.id] = item.quantity
        return acc
      }, {})

      const host = "https://beautybyearth.com/cart/"
      const itemUrl = Object.keys(data)
        .map((key) => `${key}:${data[key]}`)
        .join(",")
      const discount = "?discount=BOGOBOGO9"

      window.location.href = host + itemUrl + discount
    },
  },
  init: function () {
    document.body.addEventListener("click", function (event) {
      if (event.target.closest(".bundle-builder__container .decrease")) {
        const item = event.target.closest(".bundle-builder-item")
        Picker.Utils.handleDecrease(item)
      }

      if (event.target.closest(".bundle-builder__container .increase")) {
        const item = event.target.closest(".bundle-builder-item")
        Picker.Utils.handleIncrease(item)
      }

      if (event.target.matches(".bundle-builder__add")) {
        event.preventDefault()
        event.target.classList.add("loading")
        event.target.setAttribute("disabled", "disabled")
        Picker.Cart.processAddToCart()
      }
    })
  },
}

Picker.init()
